import { useEffect, useRef, useState } from "react";

/**
 * Wraps a counter value and runs one soft highlight fade when the value
 * changes. Value-driven, not event-driven: any refetch that moves the
 * number pulses, regardless of what triggered it.
 */
export function CountPulse({ value }: { value: number }) {
  const prev = useRef(value);
  const [active, setActive] = useState(false);
  useEffect(() => {
    if (prev.current === value) return;
    prev.current = value;
    setActive(true);
    const t = setTimeout(() => setActive(false), 600);
    return () => clearTimeout(t);
  }, [value]);
  return (
    <span
      // `count-pulse-active` is a test/semantic marker class with no CSS rule
      // (the visual comes from bg-p-600/20) — do not delete it.
      className={`inline-block rounded transition-colors duration-500 ${
        active ? "count-pulse-active bg-p-600/20" : ""
      }`}
    >
      {value}
    </span>
  );
}
